module.exports = __webpack_public_path__ + "static/media/popup-blocked-tutorial.fb1e028f.png";